import _ from "lodash";

export default class WindowEventListener {
  private static _pendingConfirmation: Map<string, Function> = new Map();

  static startListen (){

    //..for post message
    window.addEventListener("message", (event) => {
      const dataJSON = event.data as any;
      // console.log('WindowEventListener caught message', dataJSON, 'from event', event);

      let data;
      try {
        data = JSON.parse(dataJSON);
      } catch (e) {
        // console.error('WindowEventListener caught invalid json string message', dataJSON);
        return;
      }

      if (data.receivedMessageId) {
        this.onReceivedMessageId(data.receivedMessageId);
      }
    });

  }

  static onConfirmation(messageId: string, cb: Function) {
    if (!_.isFunction(cb)) {
      console.error('FATAL in onConfirmation: expect a function, got ', cb, 'stack = ', new Error());
      return;
    }

    if (this._pendingConfirmation.get(messageId)) {
      console.warn('duplicated pendingConfirmation id found ', messageId, 'stack = ', new Error());
    }
    this._pendingConfirmation.set(messageId, cb);
  }

  private static onReceivedMessageId(receivedMessageId: any) {
    let cb = this._pendingConfirmation.get(receivedMessageId);
    if (!cb) {
      console.warn('no listener registered with receivedMessageId', receivedMessageId);
      return;
    }
    cb();
  }

  static ignoreConfirmation(messageId: string) {
    this._pendingConfirmation.delete(messageId);
  }
}
